import React, {useEffect, useState} from "react";
import {CustomerDetail} from "../../model/customer/dto/customer-detail";
import {BrokerageType, CustomerMnaNeedsDto} from '../../model/customer/dto/customer-mna-needs-dto';
import SellNeedsForm from "./component/sell-needs-form";
import AcquireNeedsForm from "./component/acquire-needs-form";
import NoNeedsForm from "./component/no-needs-form";
import {useInjection} from "inversify-react";
import {CustomerInputApi} from "../../model/customer/customer-input-api";

export interface MnaInfoProp {
    data: CustomerDetail
    needs: CustomerMnaNeedsDto | undefined
    setData: React.Dispatch<React.SetStateAction<CustomerDetail>>
    setNeeds: React.Dispatch<React.SetStateAction<CustomerMnaNeedsDto | undefined>>
    needsType: BrokerageType
    setNeedsType:  React.Dispatch<React.SetStateAction<BrokerageType>>
    available: string
}

//임시저장하기 버튼 노출 여부
export const isShowTempSaveBtn = (needs: CustomerMnaNeedsDto, needsType: string) => {
    return needsType !== 'CHECK' && (!needs.isApplyNeeds || (needs.isApplyNeeds && needs.type === 'CHECK'));
}

// 알럿 조건
export const alertComment = (needs: CustomerMnaNeedsDto, needsType: string) => {
    // 신청 안한 상태
    if(!needs.isApplyNeeds) {
        return true;
    } else {
        //신청한 상태
        return needs.type === 'CHECK' && needsType !== 'CHECK';
    }
}

// 버튼 조건
export const needsBtnTitle = (needs: CustomerMnaNeedsDto, needsType: string) => {
    // 신청 안한 상태
    if(!needs.isApplyNeeds) {
        return '등록하기';
    } else {
        //신청한 상태
        if(needs.type === 'CHECK' && needsType !== 'CHECK') {
            return '등록하기';
        }

        return '저장하기';
    }
}

const MnAInfo = ({data, needs, setData, setNeeds} : MnaInfoProp) => {
    const customerInputApi = useInjection(CustomerInputApi);
    const [needsType, setNeedsType] = useState<BrokerageType>(needs?.type ?? 'NONE');
    const [available, setAvailable] = useState("");

    useEffect(() => {
        (async () => {
            if(data.customer) {
                const result = await customerInputApi.checkCanEditMnaNeeds(data.customer.id, data.customer.companyInfo.bno);

                if(result.success) {
                    setAvailable(result.data ?? '');
                }
            }

            if (needs) {
                setNeedsType(needs.type ?? 'NONE');
            }
        })();
    }, [needs]);

    if (!needs) return <div></div>;

    return(
        <>
            {(needsType === 'CHECK' || needsType === 'SELL' || needsType === 'SELL_ADVISORY') &&
                <SellNeedsForm data={data} needs={needs} setData={setData} setNeeds={setNeeds} needsType={needsType} setNeedsType={setNeedsType} available={available}/>}
            {(needsType === 'ACQUIRE' || needsType === 'ACQUIRE_ADVISORY') &&
                <AcquireNeedsForm data={data} needs={needs} setData={setData} setNeeds={setNeeds} needsType={needsType} setNeedsType={setNeedsType} available={available}/>}
            {needsType === 'NONE' && <NoNeedsForm data={data} needs={needs} setData={setData} setNeeds={setNeeds} needsType={needsType} setNeedsType={setNeedsType} available={available}/>}
        </>
    );
}

export default MnAInfo;